import React from 'react'
import {actions} from 'react-redux-form'
import {toast} from 'react-toastify'
import qs from 'qs'
import irelandApi from '../irelandApi'
import store, {history} from '../store'
import ToastMessage from '../components/common/toast-message'

export const getNewContact = () => (dispatch) => {
  dispatch({type: 'NEW_CONTACT_PENDING'});
  return irelandApi.get('/api/contacts/new')
                   .then((response) => {
                     if (response.data.user) {
                       const user = response.data.user;
                       const data = {
                         title: user.title,
                         name: user.first_name + ' ' + user.last_name,
                         outlet_id: '',
                         email: user.email,
                         telephone: user.mobile,
                         message: '',
                         type_of_enquiry: ''
                       };
                       store.dispatch(actions.load('deep.contact_us', data));
                     }
                     dispatch({type: 'NEW_CONTACT_FULFILLED', payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: 'NEW_CONTACT_REJECTED', payLoad: error.data})
                   })
};

export const saveContact = (payLoad) => {
  return irelandApi.post('/api/contacts', {'contact': payLoad})
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success"
                                                 message="Thanks for your submission"/>);
                     store.dispatch(actions.reset('deep.contact_us'));
                     // history.push('/admin/news/categories');
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error"
                                               message="An error occurred during contacting us"/>);
                     store.dispatch(actions.resetValidity('deep.contact_us'));
                     const data = {
                       ...error.response.data
                     };
                     return Promise.reject(data)
                   })
};


// WEBPACK FOOTER //
// ./src/actions/contacts.js